var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterCtgry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "currentColor",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.49.107a1.056 1.056 0 0 0-.927 0L.592 4.495a1.056 1.056 0 0 0 .028 1.91l8.972 4.057c.277.125.593.125.87 0l8.973-4.057a1.056 1.056 0 0 0 .029-1.91L10.49.107ZM3.535 5.406l6.493-3.175 6.493 3.175-6.493 2.936-6.493-2.936Z",
    clipRule: "evenodd",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 9.05a1.056 1.056 0 0 1-.506 1.405l-8.982 4.223a1.056 1.056 0 0 1-.899 0L.605 10.454a1.056 1.056 0 1 1 .9-1.91l8.514 4.01 8.532-4.01a1.056 1.056 0 0 1 1.404.506Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 13.273a1.056 1.056 0 0 1-.506 1.405L10.467 18.9a1.055 1.055 0 0 1-.899 0L.605 14.676a1.055 1.055 0 1 1 .9-1.91l8.514 4.01 8.532-4.01a1.055 1.055 0 0 1 1.404.506Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCtgry);
export default __webpack_public_path__ + "static/media/filter-ctgry.1a85c03cf6d02329bc8593963f1a5c63.svg";
export { ForwardRef as ReactComponent };